import {game, staticPath} from 'promokit-util';
import configStyle from './config.style';

const gameName = game().en;
const style = configStyle[gameName];

export default {
  'type': 'B',
  'bi': {
    'title': `${gameName}`,
    'url': '/',
    'image': {
      'large': {
        'path': style.image.large,
        'style': style.size
      },
      'medium': {
        'path': style.image.medium,
        'style': style.size
      },
      'sticky': {
        'path': style.image.mediumSticky,
        'style': style.size
      },
      'lnb': {
        'path': style.image.lnb,
        'style': style.size
      }
    }
  },
  'header': style.color,
  'theme': style.theme,
  'useLeftMenu': true,
  'useJoinMenu': true,
  'joinURL': `http://search.plaync.com/${gameName}/index.jsp`,
  'useGameStart': 'mobileGameDown',
  'gameStart': {
    'markUp': '<a href="#" class="ncc-gamestart-btn__start">다운로드</a>'
  },
  'mobileGameDown': {
    'showAndro': true,
    'showIos': true,
    'appName': '',
    'iosAppLink': '',
    'androAppLink': ''
  },
  'search': {
    'isShow': false,
    'destUrl': `http://search.plaync.com/${gameName}/index.jsp`,
    'site': `${gameName}`,
    'callback': 'suggestKeyword',
    'collection': `${gameName}1query`,
    'display': 10,
    'pos': 'lnb',
    'where': `${gameName}^tsearch`
  },
  'lnbData': [],
  'active': {
    'd1': 0,
    'd2': 0
  },
  'appDownloadData': {
    'isShow': false,
    'appList': []
  },
  'loginFN': 'GNBLogin',
  'logoutFN': 'GNBLogout',
  'useCharChangeMenu': false,
  'charChangeFN': 'characterChange'
};
